import './style.scss';
import { ReactComponent as HomePanda } from '../../../images/home-panda.svg';
import appStoreDownload from '../../../resources/images/app-store.webp';

const APP_STORE_URL = 'https://apps.apple.com/us/app/id1584854531';

const MainBanner = ({ language = 'en' }) => {
  return (
    <div className="main-banner">
      <div className="main-banner__container">
        <div className="left-part">
          <div className="text-container">
            {language === 'en' && (
              <>
                <h1>Your Personal AI for Mental Wellness</h1>
                <p>Start for free. No sign up. Chat with Panda 24/7.</p>
              </>
            )}
            {language === 'de' && (
              <>
                <h1>Dein persönlicher KI-Begleiter</h1>
                <p>Kostenlos starten. Keine Anmeldung. Panda 24/7 für dich da.</p>
              </>
            )}
          </div>
          <a
            href={APP_STORE_URL}
            target="_blank"
            rel="noreferrer"
            className="main-banner__app-store"
            aria-label="Download on the App Store"
          >
            <img src={appStoreDownload} alt="Download on the App Store" loading="eager" />
          </a>
        </div>
        <div className="right-part">
          <div className="phone-background">
            <center>
              <HomePanda className="chat-panda" />
              <a
                href={APP_STORE_URL}
                target="_blank"
                rel="noreferrer"
                className="main-banner__app-store-badge"
              >
                <img src={appStoreDownload} alt="Download on the App Store" loading="lazy" />
              </a>
            </center>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MainBanner;
